import { Controller } from "@hotwired/stimulus"

// Cache-busting timestamp: 2025-03-12T14:06:31Z
export default class extends Controller {
  static targets = ["input", "form"]

  connect() {
  }

  insertAndSubmit(event) {
    // Get the text from the clicked element
    const replyText = event.currentTarget.dataset.quickReplyText;
    
    if (this.hasInputTarget && this.hasFormTarget) {
      // Insert the text into the input field
      this.inputTarget.value = replyText;
      
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      
      // Trigger the form submission with Turbo
      //this.formTarget.requestSubmit();
    }
  }
}
